import * as React from 'react';
import { ComplexValue } from 'app/types-shared';
import { BowtieCase, DraftConnections } from '../types';
import { BowtieConnectionItem } from './bowtie-connections-item';

import styles from './bowtie-connections.scss';

interface BowtieConnectionsProps {
  draftId: number;
  caseData: BowtieCase;
  draftConnections: DraftConnections[];
  connectionTypes: ComplexValue<number>[];
  connectCase: (caseNumber: number, connectionType: number) => void;
  disconnectCase: (caseNumber: number, connectionType: number) => void;
  translation: any;
}

export class BowtieConnections extends React.PureComponent<BowtieConnectionsProps> {

  private renderConnection = (connection: ComplexValue<number>) => {

    const { caseData, draftConnections, connectCase, disconnectCase } = this.props;
    const caseDrfatConnections = draftConnections.find(conn => conn.caseNumber === caseData.caseNumber);
    const connections = caseDrfatConnections && caseDrfatConnections.connections
      ? caseDrfatConnections.connections.map(c => c.value)
      : [];

    const connected = connections.some(conn => connection.value === conn);

    return <BowtieConnectionItem key={connection.value}
      connectionType={connection.value}
      caseNumber={caseData.caseNumber}
      connected={connected}
      description={connection.description}
      icon={connection.icon}
      connectCase={connectCase}
      disconnectCase={disconnectCase}
    />;
  };

  public render() {

    const { draftId, connectionTypes, translation } = this.props;

    if (!connectionTypes || connectionTypes.length === 0) {
      return null;
    }

    return <>
      <p>
        {translation.select_connection_type} <b>#{draftId}</b>:
      </p>
      <div className={styles.connectionContainer}>
        {connectionTypes.map(this.renderConnection)}
      </div>
    </>;
  }
}
